import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import SportStrip from './components/SportStrip';
import CombatSports from './components/CombatSports';
import Schedule from './components/Schedule';
import Soccer from './components/Soccer';
import USSports from './components/USSports';
import MoreSports from './components/MoreSports';
import Banner from './components/Banner';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <SportStrip />
      <CombatSports />
      <Schedule />
      <Soccer />
      <USSports />
      <MoreSports />
      <Banner />
      <Footer />
    </div>
  );
}

export default App;
